import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  PLATFORM_ID,
  signal
} from '@angular/core';
import {CustomModalService} from '../../../../custom-component/custom-modal/service/custom-modal.service';
import {AuthService} from '../../../../services/auth.service';
import {PrivateAreaSubmenuComponent} from './mobile-menu/private-area-submenu/private-area-submenu.component';
import {GtmDatalayerService} from '../../../../services/gtm-datalayer.service';
import {GenericService} from 'src/app/services/generic.service';
import {UserService} from '../../../../services/user.service';
import {CartService} from '../../../../services/cart.service';
import {KeycloakService} from 'keycloak-angular';
import {AreaRiservataService} from '../../../../services/area-riservata.service';
import {ContentService} from 'src/app/services/content.service';
import {documentToHtmlString} from '@contentful/rich-text-html-renderer';
import {isPlatformBrowser, NgClass} from '@angular/common';
import {Router, RouterLink} from '@angular/router';
import {NotificationBarComponent} from "@shared/components/web/notification-bar/notification-bar.component";
import {APP_CONFIG, AppConfig} from "../../../../app-config.model";

@Component({
  selector: 'app-mobile-header',
  templateUrl: './mobile-header.component.html',
  styleUrls: ['./mobile-header.component.scss'],
  standalone: true,
  imports: [NgClass, RouterLink, NotificationBarComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileHeaderComponent implements OnInit, AfterViewInit{
  private readonly destroyRef = inject(DestroyRef);

  private readonly configEnv = inject<AppConfig>(APP_CONFIG);
  private readonly platformId = inject(PLATFORM_ID);
  readonly user = signal<any>(null);
  readonly isAreaRiservataLoginPage = signal(false);
  readonly showRegistrationTooltip = signal<boolean>(false);
  readonly showResetPasswordTooltip = signal<boolean>(false);
  enabledCart = this.configEnv.ENABLECART;
  readonly notificationBarText = signal<any>(null);

  constructor(
    private customModalService: CustomModalService,
    private authService: AuthService,
    private genericService: GenericService,
    private userService: UserService,
    private router: Router,
    private gtmDatalayerService: GtmDatalayerService,
    public cartService: CartService,
    private keycloak: KeycloakService,
    private contentService: ContentService,
    private areaRiservataService: AreaRiservataService
  ) {

    if(isPlatformBrowser(this.platformId)) {
      if (location.search && location.search.indexOf('notificationLogin') !== -1    ) {
        const data3 = sessionStorage.getItem('showResetPasswordTooltip');

        if (data3) {
          this.showRegistrationTooltip.set(true);
          this.showResetPasswordTooltip.set(true);
          this.hideToast();
        }
      }
      //setTimeout(() => {
      // this.userService.userSub.subscribe((res) => (this.user.set(res)));
      this.userService.userSub.subscribe((res) => {
        this.user.set(res);
        const data3 = sessionStorage.getItem('showResetPasswordTooltip');

        if (data3) {
          this.showRegistrationTooltip.set(true);
          this.showResetPasswordTooltip.set(true);
          this.hideToast();
        }
      });
      //}, 200);*/
    }
  }
  ngAfterViewInit(): void {
    this.contentService.GetNotificationBar().subscribe((res) => {
      if (res) {
        this.notificationBarText.set(documentToHtmlString(res.notification))
      }
      return res;
    })
  }

  ngOnInit(): void {
    if(isPlatformBrowser(this.platformId)) {
      if (location.search && location.search.indexOf('registrazione') !== -1) {
        this.user.set(this.authService.getUser());
        if (location.search.indexOf('modificaNumero') !== -1) {
          this.router.navigate(['area-riservata/tuoi-dati']);
          // TODO this.stateService.go(this.genericService.viewRoot() + '.AreaRiservata.TuoiDati');
        } else {
          this.showRegistrationTooltip.set(true);
          setTimeout(() => {
            this.showRegistrationTooltip.set(false);
          }, 4000);
        }
      }
      /*else {
        this.user.set(this.authService.getUser());
        if (this.user) {
          const data2 = sessionStorage.getItem('checkSessione');
          if (!data2 && location.href.indexOf('/funnel/summary') === -1) {
            this.authService.getLoginByCookie().subscribe((res) => {
              if (res) {
                sessionStorage.setItem('checkSessione', 'open');
              }
            });
          }
        }
      }*/
    }
    // TODO this.stateService.current.name ===this.genericService.viewRoot() + '.AreaRiservata.RedirectToLogin'
    if (this.router.url === '/area-riservata/login') {
      this.isAreaRiservataLoginPage.set(true);
    }
  }
  checkRoutes() {
    if (sessionStorage.getItem('prodottiCorrelati')) {
      sessionStorage.removeItem('prodottiCorrelati');
    }
  }

  async openModal() {
    const { MobileMenuComponent } = await import(
      '../mobile-header/mobile-menu/mobile-menu.component'
    );
    this.customModalService.show(MobileMenuComponent, {
      cornerLeft: false,
      cornerRight: false,
    });
  }

  async openLoginModal() {
    if(this.areaRiservataService.getIsMFAActive() && !this.user) {
      this.keycloak.login({redirectUri: window.location.origin}).then((res) => {
        console.log("LOGIN KEY CLOAK ");
      });
    } else {
      this.showRegistrationTooltip.set(false);
      this.gtmDatalayerService.trackLogin();
      this.gtmDatalayerService.trackVirtualPopup('login');
      const { LoginBoxModalComponent } = await import(
        '../mobile-header/mobile-menu/login-box-modal/login-box-modal.component'
        );
      this.customModalService.show(LoginBoxModalComponent, {
        cornerLeft: false,
        cornerRight: false,
      });
    }


  }

  gotoCart() {
    // TODO confirmare che non viene utilizzato
    //  this.stateService.go('Mobile.Cart');
  }

  openPrivateAreaModal() {
    this.showRegistrationTooltip.set(false);
    this.customModalService.show(PrivateAreaSubmenuComponent, {
      cornerLeft: false,
      cornerRight: false,
      isPrivateAreaModal: true,
      dynamicWith: '100vw',
    });
  }
  // TODO confermare che non viene utilizzato
  goToPrivateArea() {
    this.user.set(this.authService.getUser());
    if (this.user) {
      // TODO this.stateService.go('Mobile.AreaRiservata.TuoiProdotti');
    }
  }

  removeResetItem() {
    const data4 = sessionStorage.getItem('showResetPasswordTooltip');
    if (data4) {
      sessionStorage.removeItem('showResetPasswordTooltip');
    }
  }

  hideToast() {
    setTimeout(() => {
      this.showRegistrationTooltip.set(false);
      this.showResetPasswordTooltip.set(false);
      this.removeResetItem();
    }, 4000);
  }
}
